module.exports = __webpack_public_path__ + "static/media/more.8c8cdb47.svg";